module.exports = __webpack_public_path__ + "static/media/nbpl.3479f0e7.png";